import { useContext } from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';
import { DataTableContext } from '@openedx/paragon';

import messages from './messages';

const CatalogRowStatus = ({ className }: { className?: string }) => {
  const intl = useIntl();
  const {
    page, rows, itemCount, state,
  } = useContext(DataTableContext);

  const rowCount = page?.length || rows?.length || 0;
  const pageSize = state?.pageSize || 0;
  const pageIndex = state?.pageIndex || 0;
  const firstRow = pageSize * pageIndex + 1;
  const lastRow = firstRow + rowCount - 1;

  if (!rowCount) {
    return null;
  }

  return (
    <div className={className} data-testid="row-status">
      {intl.formatMessage(messages.rowStatus, {
        firstRow,
        lastRow,
        itemCount,
      })}
    </div>
  );
};

export default CatalogRowStatus;
